module.exports = __webpack_public_path__ + "static/img/avatar-3.41a180f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/users/avatar-3.jpg
// module id = vKo3
// module chunks = 1